<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <form
      class="checkout-form"
      [formGroup]="checkoutForm"
      (ngSubmit)="onSubmit()"
      [attr.aria-label]="
        'accessibility.redeem_cash_v2.checkout.calculator'
          | translate: loyaltyCurrencyTranslationParams()
      ">
      <div class="checkout-form-outer-container">
        <div class="checkout-form-inner-container">
          <div class="redeem-cash-details-container">
            <h2 class="redeem-cash-checkout-title">
              {{
                'redeem_cash.checkout.title'
                  | translate: loyaltyCurrencyTranslationParams()
              }}
            </h2>
            <div class="redeem-cash-form-container">
              <rd-rcv2-checkout-transfer-amount-form
                formControlName="transferAmountForm"
                [currencyConversionLoading]="currencyConversionLoading"
                [formData]="formData"
                [isSubmitted]="isSubmitted$"
                [redeemCashLoyaltyProgram]="redeemCashLoyaltyProgram"
                (updateCurrencyConversionLoading)="
                  setCurrencyConversionLoading($event)
                "
                [readOnlyCashFormField]="readOnlyCashFormField">
              </rd-rcv2-checkout-transfer-amount-form>
            </div>
            <div class="redeem-cash-actions-container py-4 lg:py-8">
              <ng-container
                *ngIf="
                  !featureFlagService.isAutoRedemptionEnabled;
                  else autoRedemption
                ">
                <rd-rcv2-checkout-linked-account
                  [isLoggedIn]="isLoggedIn"
                  [redeemCashMembership]="redeemCashMembership"
                  [loading]="loading"
                  [loyaltyProgram]="redeemCashLoyaltyProgram">
                </rd-rcv2-checkout-linked-account>

                <rd-shared-button
                  *ngIf="redeemCashMembership"
                  class="submit-button"
                  [buttonClass]="'submit-button'"
                  [buttonContent]="buttonContent"
                  [buttonTheme]="'primary'"
                  [buttonType]="'submit'"
                  [isDisabled]="currencyConversionLoading">
                  <ng-template #buttonContent>
                    <span
                      class="loading-text"
                      *ngIf="
                        currencyConversionLoading;
                        else currencyConversionLoaded
                      "
                      >{{
                        'redeem_cash_v2.checkout.submit_button_text_loading'
                          | translate
                      }}</span
                    >
                    <ng-template #currencyConversionLoaded>
                      <span class="submit-button-text">{{
                        'redeem_cash_v2.checkout.submit_button_text' | translate
                      }}</span>
                    </ng-template>
                  </ng-template>
                </rd-shared-button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
  <ng-container *ngSwitchCase="'loading'">
    <div class="redeem-cash-form-container">
      <div class="flex w-full items-center justify-between p-2">
        <span class="loading h-6 w-1/2 rounded-sm"></span>
      </div>
      <div class="flex w-full items-center justify-between p-2">
        <span class="content loading w-full"></span>
      </div>
      <div class="flex w-full items-center justify-between p-2">
        <span class="content loading w-full"></span>
      </div>
      <div class="flex w-full items-center justify-between p-2">
        <span class="content loading w-full"></span>
      </div>
      <div class="flex w-full items-center justify-between p-2 pb-11">
        <span class="content loading w-full"></span>
      </div>
      <div class="flex w-full items-center justify-between p-2">
        <span class="loading h-6 w-1/2 rounded-sm"></span>
      </div>
      <div
        class="flex w-full flex-col items-center justify-between p-2 lg:flex-row">
        <div
          class="flex w-full flex-col items-center justify-between p-0 lg:w-full">
          <span class="loading m-1 h-6 w-full"></span>
          <span class="loading m-1 h-11 w-full"></span>
        </div>
        <div class="loading m-6 flex h-6 w-6 flex-shrink-0"></div>
        <div
          class="flex w-full flex-col items-center justify-between p-0 lg:w-full">
          <span class="loading m-1 h-6 w-full"></span>
          <span class="loading m-1 h-11 w-full"></span>
        </div>
      </div>
      <div class="flex w-full items-center justify-between p-2 pb-11">
        <span class="loading button-height w-full lg:w-1/2"></span>
      </div>
    </div>
  </ng-container>
</ng-container>

<!--Auto redemption specific -->
<ng-template #autoRedemption>
  <rd-shared-button
    class="submit-button"
    buttonClass="submit-button"
    [dataTestid]="'rc-checkout-button-redeem-now'"
    [buttonContent]="autoRedempSubmitButton"
    buttonTheme="primary"
    (clickFn)="onSubmit()"
    [isDisabled]="currencyConversionLoading">
    <ng-template #autoRedempSubmitButton>
      <span class="submit-button-text">{{
        'redeem_cash_v2.checkout.redeem_now_text' | translate
      }}</span>
    </ng-template>
  </rd-shared-button>

  <div class="mt-8">
    <h2 class="redeem-cash-checkout-title">
      {{ 'redeem_cash_v2.auto_redemption.title' | translate }}
    </h2>

    <p>{{ 'redeem_cash_v2.auto_redemption.body' | translate }}</p>
  </div>

  <rd-shared-button
    class="submit-button auto-redemption-button"
    buttonClass="submit-button"
    [dataTestid]="'rc-checkout-button-auto-redemption'"
    [buttonContent]="autoRedemptionButton"
    buttonTheme="outline-primary"
    [isDisabled]="currencyConversionLoading"
    (clickFn)="onAutoRedemptionSubmit()">
    <ng-template #autoRedemptionButton>
      <span class="submit-button-text">{{
        'redeem_cash_v2.auto_redemption.setup' | translate
      }}</span>
    </ng-template>
  </rd-shared-button>
</ng-template>
